export default "__VITE_ASSET__Dd_KUWeG__"